import { useCallback, useState } from "react";
import { Schedule } from "../../../models/Schedule";
import ScheduleRepository from "../../../repositories/ScheduleRepository";
import {
  handleErrorLoadDataResponse,
  sortScheduleDateOptions,
} from "../../../@vendor/utils";
import { useTranslation } from "react-i18next";

export const useGetSchedule = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<Schedule[]>([]);
  const [isFetching, setIsFetching] = useState<boolean>(false);

  const loadData = useCallback(async (params = {}) => {
    setIsFetching(true);

    await ScheduleRepository.findAll(params)
      .then((resp) => {
        const { data: respData } = resp.data;
        setData(sortScheduleDateOptions(respData));
      })
      .catch((err) => {
        if (err?.code !== "ERR_CANCELED") {
          handleErrorLoadDataResponse(t, t("common.text.availableSchedule"));
        }
      })
      .finally(() => {
        setIsFetching(false);
      });
  }, []);

  return {
    data,
    isFetching,
    loadData,
  };
};
